import React from 'react'
import { connect } from 'react-redux'
import { browserHistory } from 'react-router'
import { isLZWKAPP } from '../../utils'
import { WKVisible } from '../../components/wk'
import ResellStore from './ResellStore'
import ResellNew from '../newResellPage/ResellPage'
// import ResellOrder from './ResellOrder'
import ResellMy from './ResellMy'
import tabOrderImg from '../../images/resell/tab-order.png'
import tabMyImg from '../../images/resell/tab-my.png'
import tabOrderUnImg from '../../images/resell/tab-order-unactive.png'
import tabMyUnImg from '../../images/resell/tab-my-unactive.png'
import '../../css/page/ResellPage.css'


class RecellCenterPage extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            selectId: 0,
        }
    }
    componentDidMount () {
        document.title = '分销中心'
        if (this.props.location.query.tab != null) {
            this.setState({ selectId: +this.props.location.query.tab })
        }
    }
    componentWillReceiveProps (props) {
        if (props.location.query.tab == null) {
            return
        }
        if (props.location.query.tab !== this.props.location.query.tab) {
            this.setState({ selectId: +props.location.query.tab })
        }
    }
    onClickTab (i) {
        browserHistory.replace(`/resell?tab=${i}`)
    }
    render() {
        const selectId = this.state.selectId
        return (
            <div className='wk-page resell-center-page'>
                <WKVisible show={selectId === 0 && !isLZWKAPP()}>
                    <ResellNew />
                </WKVisible>
                {selectId === 0 && isLZWKAPP() &&
                <WKVisible show={selectId === 0 && isLZWKAPP()}>
                    <ResellStore />
                </WKVisible>
                }
                <WKVisible show={selectId === 1}>
                    <ResellMy />
                </WKVisible>
                <div className={`tab wk-border-line-before`}>
                    <div className="tab-item" onClick={e => this.onClickTab(0)}>
                        <div className='item'>
                            <div className="img">
                                <img src={selectId === 0 ? tabOrderImg : tabOrderUnImg} alt=""/>
                            </div>
                            <div className={`text ${selectId === 0 ? 'active' : ''}`}>市场</div>
                        </div>
                    </div>
                    <div className="tab-item" onClick={e => this.onClickTab(1)}>
                        <div className='item'>
                            <div className="img">
                                <img src={selectId === 1 ? tabMyImg : tabMyUnImg} alt=""/>
                            </div>
                            <div className={`text ${selectId === 1 ? 'active' : ''}`}>我的</div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(state => ({
    
}))(RecellCenterPage)


// WEBPACK FOOTER //
// ./src/pages/resell/ResellCenterPage.js